import $ from 'jquery';
import init from "../init";

function setupLoadMoreButton(button, wrapper, grid) {
	button.click(function(){
		const _this = $(this);
		const url = _this.data('url');

		button.parent().addClass('-loading');

		$.get( url, function( data ) {
			const loaded = $(data);
			const loadedGrid = loaded.find('.shop-grid .cell');
			const loadedButton = loaded.find('.shop-load');

			button.parent().remove();
			grid.append(loadedGrid);

			if (loadedButton.length) {
				wrapper.append(loadedButton.parent());

				setupLoadMoreButton(loadedButton, wrapper, grid);
			}

			init(wrapper);
		});
	});
}

export default function shop() {
	const shop = $('.onlineShop');
	const shopWrapper = shop.find('.shop');
	const shopGrid = shop.find('.shop .shop-grid .grid');

	if (shop.length) {
		let loadMoreButton = shop.find('.shop-load');

		setupLoadMoreButton(loadMoreButton, shopWrapper, shopGrid);
	}
}



// WEBPACK FOOTER //
// ./source/scripts/pages/shop.js